import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ModeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"mode"}/>
}
